import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  left: 0.6rem;
  z-index: 99;
  width: 60vw;
  max-width: 58rem;
  font-size: 0.9rem;
  padding: 1rem;
  margin: 1.8rem 0;
  border-radius: 0.2rem;
  background-color: var(--white);
  border: 1px solid var(--gray_medium);
  box-shadow: 0 0.5rem 0.9rem rgba(0, 0, 0, 0.5);

  a {
    color: var(--blue);
  }

  button {
    width: 100%;
    margin-top: 0.6rem;
  }

  @media (max-width: 768px) {
    width: auto;
    margin: 1.8rem 0.6rem;
  }
`;
